import React, { FC, ReactElement } from 'react';

import { UniqueClientKey, QueryGetActiveClientByAttrArgs } from 'api/public';
import GetActiveClientByAttr from 'components/Queries/GetActiveClientByAttr';
import { isRoot } from 'utilities';
import { getSubdomain } from 'helpers';

import ClientContext from './Context';

interface IProps {
  children: ReactElement;
}

const PublicProvider: FC<IProps> = ({ children }) => {
  if (isRoot()) {
    return children;
  }

  const variables: QueryGetActiveClientByAttrArgs = {
    key: UniqueClientKey.Subdomain,
    value: getSubdomain(),
  };

  return (
    <GetActiveClientByAttr variables={variables}>
      {client => {
        // TODO: need 'as any' here because GetActiveClientByAttr returns public client, and provider holds protected client
        // we really should fix this
        const value = { client } as any;
        return <ClientContext.Provider value={value}>{children}</ClientContext.Provider>;
      }}
    </GetActiveClientByAttr>
  );
};

export default PublicProvider;
